import { wrap as CLWrap } from 'comlink'
import { ajaxUrl } from '../../helpers'

const _worker = new Worker(`${window.getRoute('workers')}fetcher-worker.js`)

/**
 *
 * @type {{
 *     fetch: (url: string) => Promise<unknown>,
 *     fetchHTML: (url: string) => Promise<unknown>,
 *     post: (url: string, data: object) => Promise<unknown>,
 * }}
 */
const fetcher = CLWrap(_worker)

export default (post_id) => ({
	post_id,
	comments: [],
	score: [],
	count: 0,

	init() {
		document.body.addEventListener('brendakookt:refresh-comments', () => {
			this.load()
		})
	},

	load() {
		fetcher.fetchHTML(window.location.href).then((response) => {
			if (response) {
				const div = document.createElement('div')
				div.innerHTML = response
				const reviews = div.querySelector('#reviews').innerHTML

				Alpine.morph(this.$root.firstElementChild, reviews)
			}
		})
	},
})
